import { render } from "./recSection.vue?vue&type=template&id=d18b76f0&scoped=true"
import script from "./recSection.vue?vue&type=script&lang=js"
export * from "./recSection.vue?vue&type=script&lang=js"

import "./recSection.vue?vue&type=style&index=0&id=d18b76f0&scoped=true&lang=css"

import exportComponent from "/Users/content/Documents/Biggie/triple_palm/photography-landing-page-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d18b76f0"]])

export default __exports__